import React from 'react';

// Composant pour protéger le texte contre l'auto-correction
const ProtectedText = ({ children, className = "", ...props }) => {
  return (
    <span 
      className={`no-transform ${className}`}
      spellCheck="false"
      autoCorrect="off"
      autoCapitalize="off"
      contentEditable="false"
      suppressContentEditableWarning={true}
      {...props}
    >
      {children}
    </span>
  );
};

// Constantes de texte protégées
export const PROTECTED_TEXTS = {
  // Navigation
  DASHBOARD: 'Dashboard',
  STOCK: 'Stock', 
  PRODUCTION: 'Production',
  VENTES: 'Ventes',
  RETOURS: 'Retours',
  DEPENSES: 'Dépenses',
  RAPPORTS: 'Rapports',
  
  // Guichets
  PAINS: 'Pains',
  VIENNOISERIE: 'Viennoiserie',
  GATEAUX: 'Gâteaux',
  
  // Produits
  PAIN_150F: 'Pain de 150F',
  PAIN_200F: 'Pain de 200F',
  CROISSANT_CHOCOLAT: 'Croissant au chocolat',
  PAIN_CHOCOLAT: 'Pain au chocolat',
  CAKE: 'Cake',
  AMANDE: 'Amande',
  PAIN_SUISSE: 'Pain suisse',
  TROPEZIENNE: 'Tropézienne',
  
  // Actions
  ENREGISTRER: 'Enregistrer',
  SUPPRIMER: 'Supprimer',
  MODIFIER: 'Modifier',
  AJOUTER: 'Ajouter',
  
  // Unités
  QUANTITE: 'Quantité',
  PRIX: 'Prix',
  DESIGNATION: 'Désignation',
  FOURNISSEUR: 'Fournisseur'
};

export default ProtectedText;